import * as actions from 'redux/constants';
import { setSdkParams } from 'redux/actions/global';
import { isIframe } from 'utilities/global';

const kortaMiddleware = store => next => action => {
  switch (action.type) {
    case actions.GET_CHECKOUT_PAGE_SUCCESS: {
      if (!isIframe()) break;

      const embedded = action.payload?.data?.kwp_additional_data?.is_embedded_view;
      // if in korta's iframe
      if (embedded) store.dispatch(setSdkParams({}, true));
      break;
    }
  }

  next(action);
};

export default kortaMiddleware;
